import axios from "axios";
export const versionInfo = params => {
  return axios.request({
    url: "/api/versionInfo/page",
    method: "get",
    params
  });
};
export const getUnitState = params => {
  return axios.request({
    url: "/api/mfa/unitState",
    method: "get",
    params
  });
};
export const getPersonalState = params => {
  return axios.request({
    url: "/api/mfa/personalState",
    method: "get",
    params
  });
};
export const saveMfaSettings = data => {
  return axios.request({
    url: "/api/mfa/saveMfaSettings",
    method: "post",
    data: data
  });
};
// 校验MFA
export const validateMFA = data => {
  return axios.request({
    url: "/api/mfa/entryUnit",
    method: "post",
    data: data
  });
};
// 绑定MFA
export const bindMFA = data => {
  return axios.request({
    url: "/api/mfa/bind",
    method: "post",
    data: data
  });
};
// 解绑MFA
export const unbindMFA = data => {
  return axios.request({
    url: "/api/mfa/unbind",
    method: "post",
    data: data
  });
};
// 获取验证码
export const validCode = data => {
  return axios.request({
    url: "/api/user/updateLoginAuth",
    method: "post",
    data: data
  });
};